__turbopack_context__.v({
  "chevron": "location-drop-module__Vy85IW__chevron",
  "dropItem": "location-drop-module__Vy85IW__dropItem",
  "dropdown": "location-drop-module__Vy85IW__dropdown",
  "label": "location-drop-module__Vy85IW__label",
  "open": "location-drop-module__Vy85IW__open",
  "searchBarInputs": "location-drop-module__Vy85IW__searchBarInputs",
  "toggle": "location-drop-module__Vy85IW__toggle",
});
